import React, {useState} from "react";
import {sha256} from "js-sha256";
import {modalServiceSubject} from "./modal.service";
import {toast} from "react-toastify";
import {
    agreements,
    env,
    errorLogStyle,
    flatPages,
    news,
    resultsUrlPrefix,
    successLogStyle,
} from "../constants/global.vars";
import {ApiService} from "../lib/http.service";
import {Storage} from "./localstorege.service";
import {
    agreementSubject,
    ConnectionStatus,
    flatPageSubject,
    homeHippodrome,
    newsSubject,
    tipstersData,
    todayResults,
    todayResultsSubject,
} from "../store/misc.store";
import iconFather from "../assets/feather/father-at-yarisi.svg";
import {wsProvider} from "../App";
import {professions} from "../constants/basic.constants";
import {wssProvider} from "./websocket.service";
import html2canvas from "html2canvas";
import {agreementModalSubject} from "./agreement-modal.service";
import InputAuto from "../pages/register/input.auto";

export let ServerTimeDifference: number = 0;
let resultsInterval: any = null;

export function getServerTime() {
    let browserDate = new Date();

    // api.start('get', env.api+'/misc/api/get-current-date/?v=' + Math.random().toString(), null, false)
    //   .then((response: any) => {
    //     if (response.status) {
    //       let serverDate = new Date(response.data.currentDate)
    //       // @ts-ignore
    //       ServerTimeDifference = (serverDate.getTime() + (serverDate.getTimezoneOffset() * 60000)) - browserDate.getTime() + (3600000 * 3);
    //     }
    //   }).catch((e: any) => {})
}

getServerTime();

let offset = new Date().getTimezoneOffset() / 60;

export function ServerDate() {
    return new Date(new Date().getTime() - offset);
}

export function useForceUpdate() {
    // @ts-ignore
    const [value, setValue] = useState(0); // integer state
    return () => setValue((value: any) => value + 1); // update the state to force render
}

export function dateFormat(eventDate: string) {
    let date = new Date(eventDate);
    date = new Date(date.setTime(date.getTime() - offset));
    return date.toLocaleDateString();
}

export function dateTimeFormat(eventDate: string) {
    let date = new Date(eventDate);
    date = new Date(date.setTime(date.getTime() - offset));
    return date.toLocaleDateString() + " " + date.toLocaleTimeString().slice(0, 5);
}

export function showAgreementModal(key: any) {
    let content = agreements[key];
    if (content === undefined || key.startsWith("fp")) {
        content = flatPages[key.replace("fp", "")];
    }
    if (content) {
        modalServiceSubject.next({
            title: content.title,
            greenBg: true,
            innerHtml: true,
            content: content.content,
            width: 720,
            confirm: {
                cancel: {
                    label: "Kapat",
                },
            },
        });
    }
}

export function showAgreementModalForRegister(key: any, element: any = null) {
    let content = agreements[key];
    if (content === undefined || key.startsWith("fp")) {
        content = flatPages[key.replace("fp", "")];
    }

    if (content) {
        document.body.style.overflow = "hidden";
        agreementModalSubject.next({
            title: content.title,
            content: content.content,
            width: 720,
            onClose: () => {
                if (element) {
                    element.target.checked = false;
                }
                document.body.style.overflow = "auto";
            },
            confirm: {
                sure: {
                    label: "Kabul Ediyorum",
                    class: "btn-success",
                    autoClose: false,
                    action: () => {
                        if (element) {
                            element.target.checked = true;
                        }
                        document.body.style.overflow = "auto";
                        agreementModalSubject.next(null);
                    },
                },
                cancel: {
                    label: "Kapat",
                    class: "btn-secondary",
                }
            }
        });
    }
}


const monthNames: any = {
    "0": "Ocak",
    "1": "Şubat",
    "2": "Mart",
    "3": "Nisan",
    "4": "Mayıs",
    "5": "Haziran",
    "6": "Temmuz",
    "7": "Ağustos",
    "8": "Eylül",
    "9": "Ekim",
    "10": "Kasım",
    "11": "Aralık",
};

export const longDays: any = {
    0: "Pazar",
    1: "Pazartesi",
    2: "Salı",
    3: "Çarşamba",
    4: "Perşembe",
    5: "Cuma",
    6: "Cumartesi",
};
export const shortDays: any = {
    0: "Pzr",
    1: "Pts",
    2: "Sal",
    3: "Çar",
    4: "Per",
    5: "Cum",
    6: "Cmt",
};

export function getDateHumanize(eventDate: string, t: any = "long") {
    var now = ServerDate();
    var date1 = new Date(now.toISOString());
    var date2 = new Date(eventDate);

    var Difference_In_Days = date2.getDate() - date1.getDate();

    let day = "";
    if (Difference_In_Days === 0) {
        day = "Bugün";
    } else if (Difference_In_Days === 1) {
        day = "Yarın";
    } else if (Difference_In_Days > 6) {
        day = date2.getDate() + " " + monthNames[String(date2.getMonth())];
    } else {
        if (t === "long") {
            day = longDays[date2.getDay()];
        } else {
            day = shortDays[date2.getDay()];
        }
    }
    return day;
}

export function dateTimeStringFormat(eventDate: string, year: any = false) {
    let date = new Date(eventDate);
    return (
        date.getDate() + " " + date.toLocaleString("tr-tr", {month: "long"}) + (year ? " " + date.getFullYear() : "")
    );
}

export function backDrop(status: boolean) {
    if (status) {
        try {
            // @ts-ignore
            document.getElementById("backdrop-blur").style.display = "block";
        } catch (e) {
        }
    } else {
        try {
            // @ts-ignore
            document.getElementById("backdrop-blur").style.display = "none";
        } catch (e) {
        }
    }
}

export function exceptionModal(e: any, option: any = null) {
    let defaultOption: any = {
        title: "Beklenmedik Bir Hata!",
        innerHtml: true,
        content: `<p>${e}</p>`,
        timeout: 5000,
        confirm: {
            cancel: {
                label: "Tamam",
            },
        },
    };
    if (option) {
        for (const [k, v] of Object.entries(option)) {
            defaultOption[k] = v;
        }
    }
    modalServiceSubject.next(defaultOption);
}

export function CurrencyFormat(price: any, decimal: number = 2) {
    if (decimal === 0) {
        return Number(price)
            .toFixed(2)
            .replace(/\d(?=(\d{3})+\.)/g, "$&#")
            .slice(0, -3)
            .replaceAll("#", ".");
    }
    return toFixedRound(Number(price), Number(decimal))
        .replace(/\d(?=(\d{3})+\.)/g, "$&#")
        .replaceAll(".", ",")
        .replaceAll("#", ".");
}

export function toFixedRound(value: any, pow: any) {
    let i = String(Number(value)).split(".");
    if (pow === 0) {
        return i[0];
    }
    return i[0] + "." + (i.length === 1 ? "00000000000000000".slice(0, pow) : (i[1] + "00000000000000000").slice(0, pow));
}

export function copyMemberNumber(text: string, message: any = null) {
    navigator.clipboard.writeText(text).then(() => {
        toast.success(message ? message : "Kopyalandı!", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: true,
            progress: undefined,
        });
    });
}

const {innerWidth: width} = window;
export let mobileView = width < 986 ? true : false;

export function getDateTimeHumanize(eventDate: string, t: any = "long") {
    var now = ServerDate();
    var date1 = new Date(now.toISOString());
    var date2 = new Date(eventDate);

    var Difference_In_Days = date2.getDate() - date1.getDate();
    let day = "";
    if (Difference_In_Days == 0) {
        day = "Bugün";
    } else if (Difference_In_Days == -1) {
        day = "Dün";
    } else if (Difference_In_Days == 1) {
        day = "Yarın";
    } else if (Difference_In_Days > 6) {
        day = date2.getDate() + " " + monthNames[String(date2.getMonth())];
    } else {
        if (t === "long") {
            day = longDays[date2.getDay()];
        } else {
            day = shortDays[date2.getDay()];
        }
    }
    return day + " " + date2.toLocaleTimeString().slice(0, 5);
}

export function loadingAnimation(state: any) {
    let loading: any = document.getElementById("id_loaderAnimation");
    if (loading) {
        if (state) {
            loading.style.display = "block";
        } else {
            loading.style.display = "none";
        }
    }
}

export function getTipsters() {
    //fixme prod a geçerken bu satır silinmeli
    Storage.del(`tipsters`);

    let cachedData = Storage.get(`tipsters`);
    if (!cachedData) {
        let api = new ApiService();
        api.start("get", env.api + "/member/api/tipsters/", null, false).then((res: any) => {
            Storage.set(`tipsters`, res.data, 1 * 60 * 1000);
            if (res.status) {
                res.data.forEach((tipster: any) => {
                    tipster.avatar = tipster.avatar ? env.api + tipster.avatar : null;
                    tipstersData[tipster.id] = tipster;
                });
            }
        });
    } else {
        cachedData.forEach((tipster: any) => {
            tipstersData[tipster.id] = tipster;
        });
    }
}

export async function getAgreements() {
    // fixme yeni kayıt eklendiğinde güncelleme için WS vs düşünülmeli
    // fixme prod ortama geçince bu satır iptal edilmeli
    Storage.del("agreements");
    let existingAgreements = Storage.get("agreements");
    if (existingAgreements) {
        for (let [k, v] of Object.entries(existingAgreements)) {
            agreements[k] = v;
        }
        agreementSubject.next({action: "loaded"});
        return agreements;
    }
    let api = new ApiService();
    api
        .start("get", env.api + "/misc/api/list-agreement/", null, false)
        .then((response: any) => {
            if (response.status) {
                for (let item of response.data) {
                    agreements[item.slug] = item;
                }
                Storage.set("agreements", agreements, 60 * 60 * 1000);
                agreementSubject.next({action: "loaded"});
            }
        })
        .catch((e: any) => {
            return null;
        })
        .finally(() => {
            return agreements;
        });
}

export async function getFlatPages() {
    // fixme yeni kayıt eklendiğinde güncelleme için WS vs düşünülmeli
    // fixme prod ortama geçince bu satır iptal edilmeli
    Storage.del("flatpages");
    let existingFlatPages = Storage.get("flatpages");
    if (existingFlatPages) {
        for (let [k, v] of Object.entries(existingFlatPages)) {
            flatPages[k] = v;
        }
        flatPageSubject.next({action: "loaded"});
        return flatPages;
    }

    let api = new ApiService();
    api
        .start("get", env.api + "/misc/api/list-flatpages/", null, false)
        .then((response: any) => {
            if (response.status) {
                for (let item of response.data) {
                    flatPages[item.slug] = item;
                }
                Storage.set("flatpages", flatPages, 60 * 1000);
                flatPageSubject.next({action: "loaded"});
            }
        })
        .catch((e: any) => {
            return null;
        })
        .finally(() => {
            return flatPages;
        });
}

export async function getNews() {
    // fixme yeni kayıt eklendiğinde güncelleme için WS vs düşünülmeli

    let api = new ApiService();
    api
        .start("get", env.api + "/misc/api/list-news/", null, false)
        .then((response: any) => {
            if (response.status) {
                response.data.forEach((item: any) => {
                    let hasAdded = news.find((e: any) => e.id === item.id);
                    if (!hasAdded) {
                        news.push(item);
                    }
                });
                Storage.set("news", news, 24 * 60 * 60 * 1000);
                newsSubject.next({action: "loaded"});
            }
        })
        .catch((e: any) => {
        })
        .finally(() => {
        });
}

export function isOnline() {
    ConnectionStatus.isConnected = true;
    console.info("%c Internet connected up again :)", successLogStyle);
}

export function isOffline() {
    ConnectionStatus.isConnected = false;
    console.info("%c Ops, Connection lost ! :(", errorLogStyle);
    if (wsProvider && wsProvider.wsHandler && wsProvider.wsHandler.readyState === 1) {
        wsProvider.wsHandler.close();
    }
}

export function getTodayResults() {
    let startDate = new Date();
    let api = new ApiService();
    let dateDay = String(startDate.getDate()).padStart(2, "0");
    if (startDate.getHours() < 6) {
        dateDay = String(Number(dateDay) - 1).padStart(2, "0");
    }
    api
        .start(
            "get",
            `${resultsUrlPrefix}/${dateDay}${String(startDate.getMonth() + 1).padStart(
                2,
                "0"
            )}${startDate.getFullYear()}/`,
            null,
            true
        )
        .then((response: any) => {
            if (response.status) {
                response.data.forEach((result: any) => {
                    result.runsMap = [];
                    result.runs.forEach((run: any) => {
                        result.runsMap[run.no] = run;
                        if (run.horses != null) {
                            run.winnerHorse = run.horses.filter((el: any) => el.result != null && el.result.toString() === "1")[0];
                            if (run.winnerHorse?.stablemate > 0) {
                                run.winnerStablemate = run.horses.filter(
                                    (e: any) => Number(e.stablemate) === Number(run.winnerHorse.stablemate)
                                );
                            }
                        }
                    });
                    todayResults[result.keyword] = result;
                    todayResultsSubject.next(true);
                });
            }
        });
    if (resultsInterval == null) {
        resultsInterval = setInterval(getTodayResults, 300 * 1000);
    }
}

export const preventBetSlipValues = (e: any) => ["e", "E", "+", "-", ",", "."].includes(e.key) && e.preventDefault();
export const preventNegativeValues = (e: any) => ["e", "E", "+", "-"].includes(e.key) && e.preventDefault();

const dateDifferenceInHours = (dateInitial: any, dateFinal: any) => (dateFinal - dateInitial) / 3_600_000;

export function showProfessionModalWss() {
    let picked: any = null;
    const onSelected = (p: any) => (picked = p);

    const content = React.createElement(
        React.Fragment,
        null,
        React.createElement(
            "p",
            { className: "mb-3 mt-3" },
            "Yasal gereklilikler nedeniyle iş ve meslek bilginizi kaydetmeniz gerekmektedir. Lütfen iş ve meslek bilginizi seçiniz"
        ),
        React.createElement("form", null, React.createElement(
            "div",
            { className: "form-row" },
            React.createElement(
                "div",
                { className: "w-100" },
                React.createElement(InputAuto, {
                    label: "Meslek",
                    data: professions,
                    onSelected: onSelected,
                })
            )
        ),),
        React.createElement(
            "p",
            { id: "errorMessage", className: "mt-1 text-danger" },
            ""
        )
    );

    setTimeout(() => {
        modalServiceSubject.next({
            title: "Meslek Bilginizi Seçin",
            cancelBackdrop: true,
            content: content,
            greenBg: true,
            confirm: {
                sure: {
                    label: "Kaydet",
                    autoClose: false,
                    async: true,
                    action: async () => {
                        if (picked) {
                            const apiService = new ApiService();
                            const response: any = await apiService.start(
                                "post",
                                env.api + "/member/api/update-account-info/",
                                {
                                    token: Storage.get("token"),
                                    profession: picked.id,
                                },
                                true
                            );
                            if (response.status) {
                                wssProvider.checkauth();
                                modalServiceSubject.next({
                                    timeout: 5000,
                                    title: "Başarılı",
                                    content:
                                        "Meslek seçiminiz başarıyla kaydedilmiştir.",
                                    confirm: null,
                                });
                                return true;
                            } else {
                                const errEl = document.getElementById(
                                    "errorMessage"
                                );
                                if (errEl) errEl.innerText = response.message;
                                return false;
                            }
                        } else {
                            const errEl = document.getElementById(
                                "errorMessage"
                            );
                            if (errEl)
                                errEl.innerText = "Lütfen meslek seçiniz.";
                            return false;
                        }
                    },
                },
            },
            timeout: 0,
        });
    }, 1000);
}

//     let optionValues = '<option value="DEFAULT">Seç</option>';
//     for (const profession of professions) {
//         optionValues += `<option value=${profession.id} key=${profession.name}>${profession.name}</option>`
//     }
//     setTimeout(() => {
//         modalServiceSubject.next({
//             closeIcon: false,
//             greenBg: true,
//             cancelBackdrop: true,
//             innerHtml: true,
//             title: 'Meslek Bilginizi Seçin',
//             content: `<p class="text-center mb-2 mt-2">Yasal gereklilikler nedeniyle iş ve meslek bilginizi kaydetmeniz gerekmektedir. Lütfen iş ve meslek bilginizi seçiniz</p><p class="text-center mb-2">Aydınlatma metnine <a class="text-primary fw-medium text-decoration-underline" id="agreement-btn" href="#">buradan</a> ulaşabilirsiniz.</p><div><select class="form-select register-select mt-2 w-100" value="DEFAULT" id="professionSelect">${optionValues}</select></div>`,
//             confirm: {
//                 sure: {
//                     label: 'Kaydet',
//                     action: () => {
//                         // @ts-ignore
//                         var profession: any = document.getElementById('professionSelect').value;
//                         if (profession != null || profession != undefined || profession != 'DEFAULT') {
//                             const apiService = new ApiService();
//                             apiService.start('post', env.api + '/member/api/update-account-info/', {
//                                 token: Storage.get('token'),
//                                 profession: profession
//                             }, true)
//                                 .then((response: any) => {
//                                     if (response.status) {

//             },
//             afterLoad: () => {
//                 // @ts-ignore
//                 document.getElementById('id_btnModelServiceSure').setAttribute('disabled', 'true');
//                 // @ts-ignore
//                 document.getElementById('id_btnModelServiceSure').classList.add('disabled');
//                 // @ts-ignore
//                 document.getElementById('id_btnModelServiceSure').classList.remove('secondary');
//                 // @ts-ignore
//                 document.getElementById('id_btnModelServiceSure').setAttribute('disabled', 'true')
//                 // @ts-ignore
//                 var professionSelect: any = document.getElementById('professionSelect');
//                 professionSelect.addEventListener('change', (event: any) => {
//                     if (event.target.value !== 'DEFAULT') {
//                         // @ts-ignore
//                         document.getElementById('id_btnModelServiceSure').classList.add('secondary');
//                         // @ts-ignore
//                         document.getElementById('id_btnModelServiceSure').classList.remove('disabled');
//                         // @ts-ignore
//                         document.getElementById('id_btnModelServiceSure').removeAttribute('disabled')
//                     } else {
//                         // @ts-ignore
//                         document.getElementById('id_btnModelServiceSure').classList.add('disabled');
//                         // @ts-ignore
//                         document.getElementById('id_btnModelServiceSure').classList.remove('secondary');
//                         // @ts-ignore
//                         document.getElementById('id_btnModelServiceSure').setAttribute('disabled', 'true')
//                     }
//                 });



export const getSHA256Hash = async (input: any) => {
    try {
        var hash = await sha256.hex(input.toString());
        return hash;
    } catch (e: any) {
        console.error(e);
    }
};


export function shareOnSocial(sharedElementId: any) {
    let element: any = document.getElementById(sharedElementId);
    if (element) {
        html2canvas(element, {
            onclone: (document: Document, el: HTMLElement) => {
                // @ts-ignore
                el.children[0].style.display = "flex";
            },
            scale: 1,
            width: element.width,
            height: element.height,
        }).then((canvas: any) => {
            const imgData = canvas.toDataURL("image/jpeg");
            shareMobile(imgData).then((r: any) => {
                if (!r) {
                    const dataUrl = canvas.toDataURL("image/png");
                    // Download the image without opening a new tab
                    const link = document.createElement("a");
                    link.href = dataUrl;
                    link.download = "kupon.png";
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                }
            });
        });
    }
}


export async function shareMobile(imgData: any) {
    const blob = await (await fetch(imgData)).blob();
    const filesArray = [
        new File(
            [blob],
            'kupon.png',
            {
                type: blob.type,
                lastModified: new Date().getTime()
            }
        )
    ];

    if (navigator.share) {
        const shareData = {
            files: filesArray
        }
        try {
            if (!(navigator.canShare(shareData))) {
                throw new Error('Cant share data.');
            }
            ;
            await navigator.share(shareData);
            return true;
        } catch (err: any) {
            console.error(err.name, err.message);
            return false;
        }
    } else {
        console.log('Native Web Sharing not supported');
        return false;
    }
}

export let appSettings = null;
export async function loadSettings() {
    const res = await fetch('/app_settings.json');
    appSettings = await res.json();
    return appSettings;
}

export function isLuckyGamesActive() {
    return appSettings?.[env.isTest ? "LUCKY_GAMES_ACTIVE_TEST" : "LUCKY_GAMES_ACTIVE_PROD"] === true;
}
